/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

import { createContextKey } from '@opentelemetry/api';

/** shared context for storing an extracted b3 debug flag */
export const B3_DEBUG_FLAG_KEY = createContextKey(
  'OpenTelemetry Context Key B3 Debug Flag'
);
